import { render } from "./ClassBoxScss.vue?vue&type=template&id=2593f127"
import script from "./ClassBoxScss.vue?vue&type=script&lang=js"
export * from "./ClassBoxScss.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/html/miw-alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__